import React from "react";

interface ResultMetric {
  value: string;
  label: string;
}

interface ServiceResultsProps {
  title?: string;
  description?: string;
  metrics: ResultMetric[];
}

const ServiceResults: React.FC<ServiceResultsProps> = ({
  title = "Real Results from Our Work",
  description = "We deliver measurable improvements in user engagement, conversion rates, and overall business performance through strategic development.",
  metrics,
}) => {
  return (
    <div className="services-outcome-wrap mt-60 mb-40">
      <h2 className="details-content-title text-center mb-20" style={{ color: "#fff" }}>{title}</h2>
      <p className="text-center mb-50" style={{ 
        color: "rgba(255,255,255,0.85)", 
        maxWidth: "800px", 
        margin: "0 auto 50px",
        fontSize: "16px",
        lineHeight: "1.7"
      }}>{description}</p>

      <div className="row">
        {metrics.map((metric, index) => (
          <div className="col-md-4 mb-30 wow fadeInUp" data-wow-delay={`${index * 100}ms`} key={index}>
            <div
              style={{
                padding: "40px 30px",
                borderRadius: "18px",
                background: "linear-gradient(135deg, rgba(255,140,0,0.15) 0%, rgba(255,140,0,0.05) 100%)",
                border: "1px solid rgba(255,140,0,0.2)",
                backdropFilter: "blur(10px)",
                textAlign: "center",
                transition: "all 0.4s cubic-bezier(0.4, 0, 0.2, 1)",
                transform: "translateY(0) scale(1)",
                cursor: "pointer",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "translateY(-10px) scale(1.05)";
                e.currentTarget.style.boxShadow = "0 25px 50px rgba(255,140,0,0.3)";
                e.currentTarget.style.background = "linear-gradient(135deg, rgba(255,140,0,0.25) 0%, rgba(255,140,0,0.1) 100%)";
                e.currentTarget.style.borderColor = "rgba(255,140,0,0.4)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "translateY(0) scale(1)";
                e.currentTarget.style.boxShadow = "none";
                e.currentTarget.style.background = "linear-gradient(135deg, rgba(255,140,0,0.15) 0%, rgba(255,140,0,0.05) 100%)";
                e.currentTarget.style.borderColor = "rgba(255,140,0,0.2)";
              }}
            >
              <h3
                style={{
                  color: "#ff8c00",
                  fontSize: "3.5rem",
                  fontWeight: "700",
                  marginBottom: "12px",
                  textShadow: "0 4px 12px rgba(255,140,0,0.3)",
                }}
              >
                {metric.value}
              </h3>
              <p style={{
                color: "rgba(255,255,255,0.9)",
                fontSize: "16px",
                fontWeight: "500",
                margin: 0,
                lineHeight: "1.5",
              }}>
                {metric.label}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ServiceResults;
